import Vue from "vue";
import Vuetify, { VTextarea, VRow , VCheckbox } from "vuetify/lib";
import i18n from "@/i18n";
import "@/sass/overrides.sass";

Vue.use(Vuetify, {
	components: {
		VTextarea,
		VRow,
		VCheckbox
	},
});

const theme = {
	background: "#ffffff",
	primary: "#213097",
	textColor: "#0C3058",
  btnColor: "#0B57D0",
	secondary: "#9C27b0",
	accent: "#9C27b0",
	info: "#00CAE3",
};

export default new Vuetify({
	rtl: ['he','ar'].includes(i18n.locale),
	lang: {
		t: (key, ...params) => i18n.t(key, params),
	},
	icons: {
		iconfont: "mdi", // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
	},
	theme: {
		dark: false,
		themes: {
			dark: theme,
			light: theme,
		},
		options: {
			customProperties: true,
		},
	},

});
